
















































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {納品データ受信型, 納品データ受信依頼型, 納品伝票明細一覧取得依頼型} from '@/type/stock/deliverydata/deliverydata';
import { 納品伝票型, 納品伝票明細型 } from '@/type/stock/deliverydata/deliverydata';
import api from '@/infrastructure/api/api';
import {processModule} from '@/store/process/process';
import {progress} from '@/script/progress';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';

import moment from 'moment';

@Component({
  components: {
    NormalDialog,
  },
  filters: {
    dateTimeFormat(deliveryData: 納品データ受信型): string {
      if (!deliveryData) {
        return '';
      }
      if (!deliveryData.受信日時) {
        return '';
      }
      moment.locale('ja');
      return moment(deliveryData.受信日時).format('YYYY/MM/DD HH:mm:ss');
    },
  },
})
export default class DeliveryDataDetail extends Vue {
  @Prop({default: false})
  private modal!: boolean;
  @Prop({default: null})
  private deliveryData!: 納品データ受信型 | null;

  private 納品伝票一覧: 納品伝票型[] = [];
  private 納品伝票明細一覧: 納品伝票明細型[] = [];

  private 選択行: number | null = null;

  @Watch('modal')
  private async ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.納品伝票一覧 = [];
      this.選択行 = null;
      this.納品伝票明細一覧 = [];
      if (this.deliveryData === null) {
        return;
      }
      if (!this.deliveryData.納品番号) {
        return;
      }
      await api.納品伝票一覧を取得する(this.deliveryData.納品番号)
        .then((response: any) => {
          this.納品伝票一覧 = response;
        })
        .catch((error: any) => {
          alert(error.data.message);
        });
      this.$modal.show('納品データ受信明細');
    }
  }

  @Emit('close')
  private 閉じる(): void {
      this.$modal.hide('納品データ受信明細');
  }

  private 卸名(納品伝票: 納品伝票型): string {
    if (納品伝票.卸名 === null || 納品伝票.卸名 === '') {
      return 納品伝票.卸コード;
    }
    return 納品伝票.卸名;
  }

  private 行が選択されている(index: number): boolean {
    return this.選択行 === index;
  }

  private リストから選択するハンドラ(index: number): void {
    this.選択行 = index;
    this.テーブル上下移動用にフォーカスする();
  }

  @Watch('選択行')
  private async 選択行が変更された(): Promise<void> {
    await progress(this.リストから選択する);
  }

  private async リストから選択する(): Promise<void> {
    if (this.選択行 === null) return;
    const 選択納品伝票 = this.納品伝票一覧[this.選択行];

    const 取得依頼: 納品伝票明細一覧取得依頼型 = {
      納品番号: 選択納品伝票.納品番号,
      卸伝票区分: 選択納品伝票.卸伝票区分,
      卸コード: 選択納品伝票.卸コード,
      卸伝票番号: 選択納品伝票.卸伝票番号,
      卸伝票日: 選択納品伝票.卸伝票日,
    };
    await api.納品伝票明細一覧を取得する(取得依頼)
      .then((response: any) => {
        this.納品伝票明細一覧 = response;
      })
      .catch((error: any) => {
        alert(error.data.message);
      });
  }

  private 納品伝票選択行入力欄ID(): string {
    return '納品伝票選択行入力欄';
  }

  private 納品伝票選択行ID(行番号: number): string {
    return '納品伝票選択行' + 行番号;
  }

  private テーブル上下移動用にフォーカスする() {
    const テーブル上下移動用入力欄 = document.getElementById(this.納品伝票選択行入力欄ID());
    if (!テーブル上下移動用入力欄) return;
    テーブル上下移動用入力欄.focus();
  }

  private スクロールする(行番号: number, スクロール方向: number) {
    // 上に戻るときだけスクロールの動きがおかしくなる時があるので
    const テーブル上下移動行 = document.getElementById(this.納品伝票選択行ID(行番号));
    const 納品伝票テーブル = document.getElementById('納品伝票テーブル');

    if (納品伝票テーブル && テーブル上下移動行) {
      納品伝票テーブル.scrollTop = 納品伝票テーブル.scrollTop + (スクロール方向 * テーブル上下移動行.offsetHeight);
    }
  }
  private keyUp(event: Event) {
    if (this.選択行 !== null) {
      this.選択行 = (this.選択行 - 1) < 0 ? 0 : this.選択行 - 1;
      this.スクロールする(this.選択行, -1);
      event.preventDefault();
    }
  }

  private keyDown(event: Event) {
    if (this.選択行 !== null) {
      this.選択行 = (this.選択行 + 1) >= this.納品伝票一覧.length ? this.納品伝票一覧.length - 1 : this.選択行 + 1;
      this.スクロールする(this.選択行, 1);
      event.preventDefault();
    }
  }

}
